/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MappingService {

    /**
     * Get list of job level mappings
     * @returns any Success
     * @throws ApiError
     */
    public static getJobLevelMappings({
        requestBody,
    }: {
        requestBody?: {
            planId: number;
            vendorLevelProfileIds?: Array<string>;
            surveyJobLevelIds?: Array<string>;
            companyJobLevelIds?: Array<number>;
        },
    }): CancelablePromise<Array<{
        planId?: number;
        surveyJobLevelId?: string;
        companyJobLevelId?: number;
    }>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mapping/level',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create job mapping
     * @returns any Success
     * @throws ApiError
     */
    public static createJobLevelMapping({
        companyJobLevelId,
        surveyJobLevelId,
        requestBody,
    }: {
        /**
         * Company Job Level ID
         */
        companyJobLevelId: number,
        /**
         * Survey Job Level ID
         */
        surveyJobLevelId: string,
        requestBody?: {
            /**
             * Plan of company
             */
            planId: number;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mapping/level/{companyJobLevelId}/{surveyJobLevelId}',
            path: {
                'companyJobLevelId': companyJobLevelId,
                'surveyJobLevelId': surveyJobLevelId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update job mapping
     * @returns any Success
     * @throws ApiError
     */
    public static updateJobLevelMapping({
        companyJobLevelId,
        surveyJobLevelId,
        requestBody,
    }: {
        /**
         * Company Job Level ID
         */
        companyJobLevelId: number,
        /**
         * Survey Job Level ID
         */
        surveyJobLevelId: string,
        requestBody?: {
            /**
             * Plan of company
             */
            planId?: number;
            /**
             * Adjustment
             */
            adjustment?: number;
            /**
             * Update Adjustment Cascade
             */
            updateAdjustmentCascade?: boolean;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/mapping/level/{companyJobLevelId}/{surveyJobLevelId}',
            path: {
                'companyJobLevelId': companyJobLevelId,
                'surveyJobLevelId': surveyJobLevelId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete job mapping
     * @returns any Success
     * @throws ApiError
     */
    public static removeJobLevelMapping({
        companyJobLevelId,
        surveyJobLevelId,
        requestBody,
    }: {
        /**
         * Company Job Level ID
         */
        companyJobLevelId: number,
        /**
         * Survey Job Level ID
         */
        surveyJobLevelId: string,
        requestBody?: {
            /**
             * Plan of company
             */
            planId: number;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/mapping/level/{companyJobLevelId}/{surveyJobLevelId}',
            path: {
                'companyJobLevelId': companyJobLevelId,
                'surveyJobLevelId': surveyJobLevelId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
